/**
 * cells/LocationCell.tsx
 *
 * Displays unit + building location.
 * Warning icon removed per spec §7 cleanup — RefreshSuggestedCell pill is the
 * sole action trigger for the EPC refresh flow.
 */
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { EPCData } from "shared/components/maintenance/hooks/useEnergyPerformanceData";
import { formatDate } from "./utils";

interface LocationCellProps {
  unit: EPCData;
  /** Still accepted for backwards-compat — kept so callers don't need to change,
   *  but the warning icon is no longer rendered here. */
  onOpenRefreshModal: () => void;
}

export function LocationCell({ unit }: LocationCellProps) {
  const hasDateInfo =
    unit.latestEpcDocumentDate || unit.latestProjectPartDate;

  const dateSubtitle = hasDateInfo ? (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="text-neutral-secondary-mid cursor-default text-xs underline decoration-dotted">
            {unit.buildingLocation}
          </span>
        </TooltipTrigger>
        <TooltipContent side="top" className="max-w-xs text-xs">
          {unit.latestEpcDocumentDate && (
            <div>EPC: {formatDate(unit.latestEpcDocumentDate)}</div>
          )}
          {unit.latestProjectPartDate && (
            <div>Werken: {formatDate(unit.latestProjectPartDate)}</div>
          )}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  ) : (
    <span className="text-neutral-secondary-mid text-xs">
      {unit.buildingLocation}
    </span>
  );

  return (
    <div className="flex flex-col gap-0.5">
      <div className="text-neutral-primary font-medium leading-tight">
        {unit.unitLocation}
      </div>
      {dateSubtitle}
    </div>
  );
}
